module.exports = {
  emptyMessage: 'Lütfen adınızı girin',
  defaultMessage: 'Geçersiz isim',
};
